import React from 'react';

interface TabSwitchProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive: boolean;
  children: React.ReactNode;
}

export const TabSwitch: React.FC<TabSwitchProps> = ({ 
  isActive, 
  children,
  className = '',
  ...props 
}) => {
  const baseClasses = 'flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all duration-200 flex-1 justify-center';
  
  const variantClasses = isActive
    ? 'bg-game-golden text-white shadow-md shadow-game-golden/20'
    : 'text-gray-400 hover:text-white hover:bg-game-medium/40';
  
  const finalClassName = `${baseClasses} ${variantClasses} ${className}`.trim();

  return (
    <button 
      type="button"
      className={finalClassName}
      {...props}
    >
      {children}
    </button>
  );
};